import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Box, Typography, ButtonBase, Popover, TextField } from '@mui/material';

const ColorPickerComponent = ({ color, onChange, label }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleColorChange = (newColor) => {
    onChange(newColor);
  };

  return (
    <Box>
      <Typography variant="body2" gutterBottom>
        {label}
      </Typography>
      <ButtonBase
        onClick={handleClick}
        sx={{
          width: '100%',
          height: 50,
          backgroundColor: color,
          border: '2px solid #ccc',
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          '&:hover': {
            border: '2px solid #1976d2',
          },
          '&:focus': {
            outline: '2px solid #1976d2',
            outlineOffset: 2,
          }
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            color: getContrastColor(color),
            fontWeight: 'bold',
            textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
          }}
        >
          {color}
        </Typography>
      </ButtonBase>
      
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            boxShadow: 3,
            borderRadius: 2,
          }
        }}
      >
        <Box sx={{ p: 2 }}>
          <HexColorPicker 
            color={color} 
            onChange={handleColorChange}
            style={{
              width: '200px',
              height: '150px'
            }}
          />
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              size="small"
              label="Hex"
              value={color}
              onChange={(e) => {
                const value = e.target.value;
                if (/^#[0-9A-Fa-f]{0,6}$/.test(value)) {
                  handleColorChange(value);
                }
              }}
              sx={{ width: 100 }}
            />
            <Box 
              sx={{ 
                width: 30, 
                height: 30, 
                backgroundColor: color,
                border: '1px solid #ccc',
                borderRadius: 1,
                flexShrink: 0
              }} 
            />
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default ColorPickerComponent;

// Función helper para obtener color de contraste
const getContrastColor = (hexColor) => {
  // Convertir hex a RGB
  const r = parseInt(hexColor.substr(1, 2), 16);
  const g = parseInt(hexColor.substr(3, 2), 16);
  const b = parseInt(hexColor.substr(5, 2), 16);
  
  // Calcular luminancia
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
};